import React, { useState, useEffect } from "react";
import { Button, Table, Tab, Spinner } from "react-bootstrap";
import Pagination from "../../../../components/Pagination";
import { del } from "../../../../helpers/api_helper";
import VideoModal from "./modals/videoModal";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import TutorialRow from "./tutorialRow";

const TutorialTable = ({
  tutorialData,
  handleEditTutorial,
  handlePageChange,
  totalPages,
  currentPage,
  setRefresh,
}) => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [tutorialToDelete, setTutorialToDelete] = useState(null);

  useEffect(() => {
    if (tutorialData && tutorialData.length > 0) {
      setLoading(false);
    }
  }, [tutorialData]);

  const handleDelete = async () => {
    try {
      const response = await del(`/tutorial/${tutorialToDelete}`);
      if (response.success) {
        setRefresh(true);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (id) => {
    setTutorialToDelete(id);
    setShowConfirm(true);
  };

  const renderTable = (tutorials) => (
    <Table responsive>
      <thead>
        <tr>
          <th className="fw-normal border-0">Thumbnail</th>
          <th className="fw-normal border-0">Title</th>
          <th className="fw-normal border-0">Description</th>
          <th className="fw-normal border-0">Type</th>
          <th className="fw-normal border-0">Media Type</th>
          <th className="fw-normal border-0">Created At</th>
          <th className="fw-normal border-0">Status</th>
          <th className="fw-normal border-0">Actions</th>
        </tr>
      </thead>
      <tbody>
        {tutorials.length === 0 ? (
          <tr>
            <td colSpan="8" className="text-center">
              <p>No files found.</p>
            </td>
          </tr>
        ) : (
          tutorials?.map((tutorial) => (
            <TutorialRow
              key={tutorial._id}
              tutorial={tutorial}
              handleEditTutorial={handleEditTutorial}
              confirmDelete={confirmDelete}
              setVideoUrl={setVideoUrl}
              setShowVideoModal={setShowVideoModal}
            />
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <>
      <Tab.Content>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100px" }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <Tab.Pane eventKey="All">
              {renderTable(tutorialData)}
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="Free">
              {renderTable(tutorialData.filter((tutorial) => !tutorial.paid))}
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="Paid">
              {renderTable(tutorialData.filter((tutorial) => tutorial.paid))}
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </Tab.Pane>
          </>
        )}
      </Tab.Content>
      <VideoModal
        show={showVideoModal}
        handleClose={() => setShowVideoModal(false)}
        videoUrl={videoUrl}
      />
      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default TutorialTable;
